import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Section = styled.section`
  max-width: 827px;
  margin-top: 2rem;
  padding-top: 1.5rem;
  scroll-margin-top: 84px;
  @media (min-width: ${breakpoints.md}) {
    scroll-margin-top: 108px;
  }
`;

export const Title = styled.div`
  ${theme.typography.labelLarge}
  margin-bottom: 20px;
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleLarge}
    margin-bottom: 24px;
  }
`;
